import { z } from 'zod';

export const clientSpecMapSchema = z.record(
  z.object({
    appDefinitionId: z.string().optional(),
    permissions: z.object({ revoked: z.boolean() }).optional(),
    instanceId: z.string().optional(),
  })
);

export const createMetaSiteFromTemplateSchema = z.object({
  metaSite: z.object({
    metaSiteId: z.string(),
  }),
});

export const getMetaSiteUrlSchema = z.object({
  url: z.string(),
  published: z.boolean(),
});
